var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupportIcon = function SvgSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#support-icon_svg__a)",
    fill: "#12B76A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 16.242a7.782 7.782 0 0 0-4.268-6.93c-.079 5.71-4.709 10.34-10.419 10.42a7.782 7.782 0 0 0 6.93 4.267 7.73 7.73 0 0 0 3.947-1.078l3.776 1.044-1.045-3.776A7.73 7.73 0 0 0 24 16.242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.328 9.164C18.328 4.111 14.218 0 9.164 0 4.111 0 0 4.11 0 9.164c0 1.647.438 3.25 1.27 4.658L.035 18.294l4.472-1.237a9.135 9.135 0 0 0 4.658 1.271c5.053 0 9.164-4.11 9.164-9.164ZM7.758 7.031H6.352A2.816 2.816 0 0 1 9.164 4.22a2.816 2.816 0 0 1 2.813 2.812 2.82 2.82 0 0 1-.915 2.076L9.867 10.2v1.097H8.461V9.58l1.652-1.512a1.408 1.408 0 0 0-.948-2.444c-.776 0-1.407.63-1.407 1.406Zm.703 5.672h1.406v1.406H8.461v-1.406Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "support-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSupportIcon;